export enum AccountTypes {
  admin = 'ADMIN',
}
